
import LazyLoad from './src/LazyLoad'
export default LazyLoad



// WEBPACK FOOTER //
// ./components/vc-lazy-load/index.js